import type { Components, Theme } from "@mui/material/styles";

const LINE_WIDTH = 2;
// Half of MuiStepLabel's 16px icon, minus half of the line width so the line
// renders centered under the dot. MUI's default targets a 24px icon, which
// leaves the vertical line drifted right when we shrink the icon to 16px.
const VERTICAL_LINE_OFFSET = 16 / 2 - LINE_WIDTH / 2;

export const MuiStepConnector: NonNullable<
  Components<Theme>["MuiStepConnector"]
> = {
  styleOverrides: {
    line: ({ theme }) => ({
      borderTopWidth: LINE_WIDTH,
      borderLeftWidth: LINE_WIDTH,
      borderColor: theme.vars!.palette.rmh.stateBorder.disabled,
    }),
    vertical: {
      marginLeft: VERTICAL_LINE_OFFSET,
    },
    root: ({ theme }) => ({
      // Stepper marks the connector with `Mui-active` (next step is active —
      // i.e. preceding step is done) and `Mui-completed` (the connector itself
      // sits between two completed steps). Both render as the brand line.
      "&.Mui-active .MuiStepConnector-line, &.Mui-completed .MuiStepConnector-line":
        {
          borderColor: theme.vars!.palette.rmh.border["5-brand"].rest,
        },
    }),
  },
};
